
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Checkbox } from '@/components/atoms';
import { EDayOfTheWeek } from '@/api/OpeningHoursService';
import { upperCaseFirstLetter } from '@/utils/string';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: { Checkbox, Typography }
})
export default class SelectDayOfWeek extends Vue {
  @Prop() value?: string;
  // When true ("Redeemable on any day"), every day renders checked even though
  // `value` is empty — the grid stays mounted, so it must reflect `value` reactively.
  @Prop({ default: false }) allSelected?: boolean;

  get daysOfWeek() {
    return Object.values(EDayOfTheWeek);
  }

  data: Record<string, boolean> = {};

  @Watch('value', { immediate: true })
  syncFromValue(value?: string) {
    const next: Record<string, boolean> = {};
    if (value) {
      value.split(',').forEach(day => {
        next[day.trim()] = true;
      });
    }
    this.data = next;
  }

  isChecked(index: number) {
    return this.allSelected || !!this.data[String(index)];
  }

  changedDay(index: number) {
    let selected: string[];
    if (this.allSelected) {
      // All days are shown checked; this click unchecks a single day.
      selected = this.daysOfWeek
        .map((_, i) => String(i))
        .filter(day => day !== String(index));
    } else {
      const next = { ...this.data };
      if (next[String(index)]) {
        delete next[String(index)];
      } else {
        next[String(index)] = true;
      }
      selected = Object.keys(next);
    }

    this.$emit('input', selected);
  }

  upperDayOfWeek(day: string) {
    return upperCaseFirstLetter(day);
  }
}
